
import { Link } from 'react-router-dom';
import BreadCrumb from "../FieldComponets/BreadCrumb";
import React from 'react';

const PageLayout = ({ title, breadcrumbs, children, buttons,text }: any) => {
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">{title}</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        {breadcrumbs && <BreadCrumb {...breadcrumbs} />}
                                    </ol>
                                </div>
                                {/* Conditionally Render Buttons */}
                            </div>
                            <small className='fw-bold d-block mb-4'>{text}</small>

                                <div className="page-title-buttons d-flex flex-wrap justify-content-end align-items-center gap-2 mb-3">
                                    {buttons && buttons.map((button:any, index:any) => (
                                        button.show && (
                                            <Link key={index} to={button.url} className={button.className}>
                                                {button.text}
                                            </Link>
                                        )
                                    ))}
                                </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 custom-table">
                            {/* Rest of the layout content */}
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageLayout;